var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9375 4.06066L8.87687 8.00003L4.9375 11.9394L5.99816 13L10.9982 8.00003L5.99816 3L4.9375 4.06066Z",
    fill: "#0C0324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowChevronDown);
export default __webpack_public_path__ + "static/media/arrow-chevron-down.10e280cc5f8e070ca314fdf5058f32c1.svg";
export { ForwardRef as ReactComponent };